import { render, staticRenderFns } from "./reminder-icon.vue?vue&type=template&id=60c79dfb"
import script from "./reminder-icon.vue?vue&type=script&lang=js"
export * from "./reminder-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports